import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ColorContext = /*#__PURE__*/React.createContext({});
if (process.env.NODE_ENV !== 'production') {
  ColorContext.displayName = 'ColorContext';
}
export function ColorProvider(props) {
  const {
    colorProcessors,
    children
  } = props;
  return /*#__PURE__*/_jsx(ColorContext.Provider, {
    value: colorProcessors,
    children: children
  });
}